import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
  Input,
} from '@angular/core';
import { BRAND_NAME } from '@rd/core/tokens/rd-lib.token';
import { UrlUtilsService } from '../../services/url-utils/url-utils.service';

@Component({
  selector: 'rd-core-main-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FooterComponent {
  @HostBinding('class.rd-core-main-footer') componentClass = true;

  @Input() isLoggedIn: boolean | null = null;

  constructor(
    @Inject(BRAND_NAME) protected brandName: string,
    protected urlUtilsService: UrlUtilsService,
  ) {}

  footerCopyrightTextContentParams(): { brand: string } {
    return {
      brand: this.brandName,
    };
  }

  logoImageUrl(): string {
    return this.urlUtilsService.imageUrl('/images/rd/footer-logo.png');
  }
}
